import { createStructuredSelector } from "reselect";
import {
    USER_ROLE_LIST,
    USER_ROLE_LIST_SUCCESS,
    USER_ROLE_LIST_ERROR,
    USER_ROLE_PAGE_SET,
    USER_ROLE_HEADER,
    USER_ROLE_SEARCH_SET,
    USER_ROLE_SEARCH_CHANGE,
    USER_ROLE_MODAL_SET,
    USER_ROLE_SET_DATA,
    USER_ROLE_SET_DATA_UPDATE,
    USER_ROLE_UPDATE,
    USER_ROLE_UPDATE_SUCCESS,
    USER_ROLE_UPDATE_ERROR,
    USER_ROLE_TAB_SET,
    EXTERNAL_USER_ROLE_LIST,
    EXTERNAL_USER_ROLE_LIST_SUCCESS,
    EXTERNAL_USER_ROLE_LIST_ERROR,
    EXTERNAL_USER_ROLE_SET_DATA,
    EXTERNAL_USER_ROLE_SET_DATA_UPDATE,
    EXTERNAL_USER_ROLE_UPDATE,
    EXTERNAL_USER_ROLE_UPDATE_SUCCESS,
    EXTERNAL_USER_ROLE_UPDATE_ERROR,
    EXTERNAL_USER_ROLE_MODAL_SET
} from "../actions";

export const NAME = 'userRole';

export const UserRoleList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: USER_ROLE_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const UserRoleListSuccess = (data) => ({
    type: USER_ROLE_LIST_SUCCESS,
    payload: data
});

export const UserRoleListError = (error) => ({
    type: USER_ROLE_LIST_ERROR,
    payload: error
});

export const UserRolePageSet = (data) => ({
    type: USER_ROLE_PAGE_SET,
    payload: data
});

export const UserRoleHeader = (data) => ({
    type: USER_ROLE_HEADER,
    payload: data
})

export const UserRoleSearchSet = (data) => ({
    type: USER_ROLE_SEARCH_SET,
    payload: data
});

export const UserRoleSearchChangeSet = (data) => ({
    type: USER_ROLE_SEARCH_CHANGE,
    payload: data
});

export const UserRoleModalSet = (data) => ({
    type: USER_ROLE_MODAL_SET,
    payload: data
});

export const UserRoleSetData = (data) => ({
    type: USER_ROLE_SET_DATA,
    payload: data
});

export const UserRoleSetDataUpdate = (data) => ({
    type: USER_ROLE_SET_DATA_UPDATE,
    payload: data
});


export const UserRoleUpdate = (data) => ({
    type: USER_ROLE_UPDATE,
    payload: data
});

export const UserRoleUpdateSuccess = (message) => ({
    type: USER_ROLE_UPDATE_SUCCESS,
    payload: message
});

export const UserRoleUpdateError = (error) => ({
    type: USER_ROLE_UPDATE_ERROR,
    payload: error
});

export const UserRoleTabSet = (data) => ({
    type: USER_ROLE_TAB_SET,
    payload: data
});

export const ExternalUserRoleList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: EXTERNAL_USER_ROLE_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ExternalUserRoleListSuccess = (data) => ({
    type: EXTERNAL_USER_ROLE_LIST_SUCCESS,
    payload: data
});

export const ExternalUserRoleListError = (error) => ({
    type: EXTERNAL_USER_ROLE_LIST_ERROR,
    payload: error
});

export const ExternalUserRoleModalSet = (data) => ({
    type: EXTERNAL_USER_ROLE_MODAL_SET,
    payload: data
});


export const ExternalUserRoleSetData = (data) => ({
    type: EXTERNAL_USER_ROLE_SET_DATA,
    payload: data
});

export const ExternalUserRoleSetDataUpdate = (data) => ({
    type: EXTERNAL_USER_ROLE_SET_DATA_UPDATE,
    payload: data
});


export const ExternalUserRoleUpdate = (data) => ({
    type: EXTERNAL_USER_ROLE_UPDATE,
    payload: data
});

export const ExternalUserRoleUpdateSuccess = (message) => ({
    type: EXTERNAL_USER_ROLE_UPDATE_SUCCESS,
    payload: message
});

export const ExternalUserRoleUpdateError = (error) => ({
    type: EXTERNAL_USER_ROLE_UPDATE_ERROR,
    payload: error
});

const userRole = (state) => state[NAME];

export const UserRoleSelector = createStructuredSelector({
    userRole
})
